<div class="row">
  @if (file || control.placeholder) {
    <div
      class="col-10 d-flex align-items-center"
      >
      <input
        [attr.id]="controlId"
        nbInput
        fieldSize="medium"
        fullWidth
        [status]="control.colorStatus"
        [placeholder]="file ? fileName : (control.placeholder | translate)"
        [value]="file ? fileName : null"
        readonly
        />
      </div>
    }
    <div class="col-2">
      <button
        size="medium"
        nbButton
        type="button"
        status="primary"
        (click)="btnClick()"
        >
        {{ control.buttonPlaceholder | translate }}
      </button>
      <input #fileTag type="file" class="inputfile" />
    </div>
  </div>
